import React, { useState } from "react";

import {
    mascaraCep,
    checkCEP,
    handleReset
} from "./functions";

import { Button } from "../../Button";
import { Input } from "../../Input";

import Modal from "react-bootstrap/Modal";
import { Socios } from "../../../pages/Cliente/Cadastro/Cadastro";
import "./styles.css";

interface modalProps {
    modal: boolean;
    setModal: (modal: boolean) => void;
    socios: Socios[];
    setSocios: React.Dispatch<React.SetStateAction<Socios[]>>
}

export const ModalCadastroSocio = ({
    modal,
    setModal,
    socios,
    setSocios,
}: modalProps) => {
    const [error, setError] = useState<boolean>(false);

    const [nome, setNome] = useState<string>("");
    const [cep, setCep] = useState<string>("");
    const [rua, setRua] = useState<string>("");
    const [bairro, setBairro] = useState<string>("");
    const [cidade, setCidade] = useState<string>("");
    const [estado, setEstado] = useState<string>("");
    const [complemento, setComplemento] = useState<string>("");

    function adicionarSocio() {
        setSocios([...socios,
        {
            nome: nome.trim(),
            endereco:
            {
                rua: rua.trim(),
                complemento: complemento.trim(),
                bairro: bairro.trim(),
                cidade: cidade.trim(),
                estado: estado.trim(),
                cep
            }
        }]);
        handleReset(setNome, setCep, setRua, setBairro, setCidade, setEstado, setComplemento, setError, setModal);
    }

    function handleConfirm() {
        nome.trim() === "" || cep.trim() === "" || rua.trim() === "" || bairro.trim() === "" || cidade.trim() === "" || estado.trim() === "" || complemento.trim() === "" ?
            setError(true)
            :
            adicionarSocio()
    }

    return (
        <div>
            <Modal
                show={modal}
                dialogClassName="modal-cadastro-socio"
                onHide={() => handleReset(
                setNome,
                setCep,
                setRua,
                setBairro,
                setCidade,
                setEstado,
                setComplemento,
                setError,
                setModal
            )}>
                <Modal.Header closeButton>
                    <Modal.Title>Adicionar sócio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-cadastro-socio-grid">
                    <Input required={true} type="text" label="Nome do Sócio" placeholder="Nome do Sócio" id={"nome"} value={nome} onChange={(e) => setNome(e.target.value)} />
                    <Input required={true} label="CEP" placeholder="CEP" id={"cep"} value={cep} onChange={(e: any) => mascaraCep(
                        e.target.value,
                        setCep
                    )} onBlur={
                        () => checkCEP(
                            setRua,
                            setBairro,
                            setCidade,
                            setEstado,
                            cep
                        )}
                    />
                    <Input required={true} label="Cidade" placeholder="Cidade" id={"cidade"} value={cidade} onChange={(e) => setCidade(e.target.value)} />
                    <Input required={true} label="Estado" placeholder="Estado" id={"estado"} value={estado} onChange={(e) => setEstado(e.target.value)} />
                    <Input required={true} label="Bairro" placeholder="Bairro" id={"bairro"} value={bairro} onChange={(e) => setBairro(e.target.value)} />
                    <Input required={true} label="Endereço" placeholder="Endereço" id={"endereco"} value={rua} onChange={(e) => setRua(e.target.value)} />
                    <Input required={true} label="Número e Complemento" placeholder="Número e Complemento" id={"complemento"} value={complemento} onChange={(e: any) => setComplemento(e.target.value)} />
                    </div>

                    {
                        error === true &&
                        <p className="modal-cadastro-socio-error">Verifique se todos os campos foram preenchidos corretamente.</p>
                    }
                </Modal.Body>
                <Modal.Footer className="modal-cadastro-socio-footer">
                    <Button
                        classNameButton="btn__laranja modal-cadastro-socio-button"
                        titleButton="Adicionar"
                        onClick={() => { handleConfirm() }}
                    />
                    <Button
                        classNameButton="btnCancelar modal-cadastro-socio-button"
                        onClick={() => { setModal(false); setError(false) }}
                        titleButton="Cancelar"
                    />
                </Modal.Footer>

            </Modal>
        </div>
    );
};
